import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

class Label extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        values: PropTypes.string,
        style: PropTypes.object,
        children: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.number,
            PropTypes.string,
            PropTypes.arrayOf(PropTypes.string)
        ])
    }
    static defaultProps = {
        children: false,
        values: {},
        style: {}
    }

    render() {
        const {className='label', values, style} = this.props;
        const label = this.props.children
        const labels = label ? Array.isArray(label) ? label : [label] : false

        /*defaultMessage={label.split('.').pop()} */
        if(!label) return ''
        return <label {...{className, style}}>
            {labels.map(label => <FormattedMessage id={label + ''} values={values} key={label} defaultMessage={label + ''} />).reduce((r, a) => r.concat(a, ' '), [])}
        </label>
    }
}

export default Label;
